<app-page-header [heading]="'Purchase Order List'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class="row">
    <div class="col-lg-8 d-flex align-items-center justify-content-end">
      <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/purchase-order/new-purchase-order"
         title="Create new purchase order">&nbsp;<i
        class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
    </div>
    <div class="col-lg-4">
      <div class="input-group">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="order.search_order" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Supplier Name/Order no/ Date..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="order.search_order != ''" class="fa fa-close"></i>
            <i *ngIf="order.search_order == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>

  <div class="">
    <table class="table tbl  table-hover table-striped  table-bordered">
      <thead>
      <tr>
        <th width="1%">Sl#</th>
        <th> Supplier Name</th>
        <th width="15%"> Order Number</th>
        <th width="15%">Order Date</th>
        <th width="15%">Grand Total</th>
        <th width="15%">Action</th>
      </tr>
      <tr *ngIf="(order_data | json) == '[]'">
        <td class="text-center" colspan="8">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of order_data;let i=index" style="font-size: 12px">
        <td [class.text-primary]="data.PAYMENT_REFERENCE != '' " class="text-center"> {{ start + i + 1 }}</td>
        <td [class.text-primary]="data.PAYMENT_REFERENCE != '' ">{{ data.VENDOR_NAME }}</td>
        <td [class.text-primary]="data.PAYMENT_REFERENCE != '' " class="text-center">{{ data.PURCHASE_ORDER_NUMBER }}
        </td>
        <td [class.text-primary]="data.PAYMENT_REFERENCE != '' "
            class="text-center">{{ utils.date(data.PURCHASE_ORDER_DATE) }}
        </td>
        <td [class.text-primary]="data.PAYMENT_REFERENCE != ''" class="text-center">{{ data.GRAND_TOTAL }}</td>
        <td style="display: grid;grid-template-columns: repeat(7,30px)">
          <button (click)="purached_order_items(data);open(content);" alt="View"
                  class="btn btn-xs btn-margin btn-success" style="font-size:10px"
                  title="View"><i class="fa fa-eye"></i></button>&nbsp;&nbsp;
          <a
            *ngIf="user_rights.EDIT == '1' && data.PAYMENT_REFERENCE == ''  || data.PAYMENT_REFERENCE == null || user_rights.EDIT == '1' && user_rights.APPROVE == '1' && user_data.user_id == data.USER_ID"
            alt="Edit" class="btn btn-xs btn-margin btn-dark"
            routerLink="/purchase-order/new-purchase-order/edit/{{data.PURCHASE_ORDER_ID}}" style="font-size:10px"
            title="Edit"><i
            class="fa fa-edit"></i></a>
          <ng-container
            *ngIf="user_rights.EDIT == '1' && user_rights.APPROVE  == 0 &&  data.PAYMENT_REFERENCE && user_data.user_id  != data.USER_ID">
            <button alt="Edit" class="btn btn-xs btn-margin btn-secondary" style="font-size:10px" title="Edit"><i
              class="fa fa-edit"></i></button>
          </ng-container>
          <ng-container
            *ngIf="user_rights.EDIT == '1' && user_rights.APPROVE  == 1 &&  data.PAYMENT_REFERENCE && user_data.user_id  != data.USER_ID">
            <button alt="Edit" class="btn btn-xs btn-margin btn-secondary" title="Edit"><i class="fa fa-edit"></i>
            </button>
          </ng-container>
          <ng-container
            *ngIf="data.PAYMENT_REFERENCE == null || data.PAYMENT_REFERENCE == '' &&  user_rights.APPROVE == '1'">
            &nbsp;&nbsp;<button
            (click)="purached_order_items(data);close(reference);payment_pop(data.PURCHASE_ORDER_ID)"
            alt="Payment Reference" class=" btn btn-xs btn-margin btn-warning"
            style="font-size:10px;color: black;"
            title="Payment Reference">
            <i class="fa fa-check-circle "></i></button>
          </ng-container>
          <ng-container *ngIf="data.PAYMENT_REFERENCE &&  user_rights.APPROVE == '1'">
            &nbsp;&nbsp;<button
            (click)="purached_order_items(data);close(reference);payment_pop(data.PURCHASE_ORDER_ID)"
            alt="Payment Reference" class=" btn btn-xs btn-margin btn-warning"
            style="font-size:10px;color: black;"
            title="Payment Reference">
            <i class="fa fa-check-circle "></i></button>
          </ng-container>
          &nbsp;&nbsp;<button (click)="deletePO(data);" alt="Delete" class=" btn btn-xs btn-margin btn-danger"
                              style="font-size:10px" title="Delete"><i
          class="fa fa-trash"></i></button>

        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="getorderList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>
<ng-template let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Order Close Reason
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <textarea [(ngModel)]="close_reason" class="form-control" name="close_reason" style="height: 168px; "></textarea>
    <div class="clearfix"></div>
    <button (click)="closeOrder();modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
            class="btn-info  pull-right btn-sm ng-star-inserted">Close Order
    </button>
  </div>
</ng-template>
<ng-template #reference let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Payment Details
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="row justify-content-end">
          <div class="form-group col-lg-12">
            <label for="date">Payment Reference No</label>
            <input [(ngModel)]="purchase_order.payment_reference" class="form-control " name="payment"
                   type="text">
          </div>
          <div class="form-group col-lg-12">
            <label for="date">Reference Date</label>
            <input (ngModelChange)="purchase_order.reference_date = $event" [max]="getToday()"
                   [ngModel]="purchase_order.reference_date | date:'yyyy-MM-dd' "
                   class="form-control " id="Reference" name="Reference"
                   type="date">
          </div>
          <div class="clearfix"></div>
          <div class="form-group text-center col-lg-12">
            <button (click)="modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                    class="btn-warning btn  btn-sm ng-star-inserted"
                    style="color:#fff">Close
            </button>&nbsp;&nbsp;&nbsp;
            <button (click)="savePaymentDetails();modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                    class="btn-info btn  btn-sm ng-star-inserted">Save
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #content let-modal>
  <div class="modal-header" style="background-color: #bbd6f1;">
    <div class="d-flex justify-content-between w-100 align-items-center">
      <h4 class="modal-title" id="modal-basic-title">
        Particular List
      </h4>
      <div class="d-flex justify-content-end">

        <button *ngIf="user_rights.EDIT == '1'" [useExistingCss]="true" class="btn  btn-info btn-sm ng-star-inserted"
                ngxPrint printSectionId="printOrder"><i class="fa fa-print"></i>&nbsp;&nbsp;Print&nbsp;
        </button>&nbsp;&nbsp;&nbsp;
      </div>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div *ngIf="orderd" class="row">
          <div class="col-lg-4">
            <div class="row">
              <div class="col-lg-4">
                <label>Vendor Name</label>
              </div>
              <div class="col-lg-8">
                :&nbsp;<span class="tle">{{ orderd.VENDOR_NAME }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="row">
              <div class="col-lg-4">
                <label>Order No</label>
              </div>
              <div class="col-lg-8">
                :&nbsp; <span class="tle">{{ orderd.PURCHASE_ORDER_NUMBER }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="row">
              <div class="col-lg-4">
                <label>Order Date</label>
              </div>
              <div class="col-lg-8">
                :&nbsp; <span class="tle">{{ orderd.PURCHASE_ORDER_DATE | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="panel-body">
          <table class="table tbl  table-bordered" style="background-color: #f3f8fd">
            <thead>
            <tr class="text-center">
              <th>Sl</th>
              <th width="35%">Particular</th>
              <th>Quantity</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Total Price</th>
              <th>Last Purchase Price</th>
              <th>Last Purchase Date</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of item_list;let i=index">
              <td class="text-center">{{ 1 + i }}</td>
              <td> {{ item.TRADE_NAME }}</td>
              <td class="text-center">{{ item.QUANTITY }}</td>
              <td class="text-center">{{ item.UNIT_DESC }}</td>
              <td class="text-right">{{ item.UNIT_PRICE }}</td>
              <td class="text-right">{{ item.TOTAL_AMOUNT }}</td>
              <td class="text-right">{{ item.LAST_PURCHASE_UNIT_PRICE }}</td>
              <td>{{ item.LAST_DATE }}</td>
            </tr>

            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="a4-page" style="display: none">
  <div id="printOrder">
    <div *ngIf="orderd"
         style="font-size: 12px; font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';">
      <!--Header-->
      <div style="display:grid;grid-template-columns: 58% 42%;">
        <div style="align-items: center;justify-content: flex-start;display: flex;">
          <ng-container *ngIf="institution.INSTITUTION_LOGO">
            <img alt="" height="60" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" style="object-fit: contain;display: block;margin-left: 0;width: auto"
                 width="60">
          </ng-container>
        </div>
        <div>
          <ng-container *ngIf="institution">
            <h5 style="font-size: 16px;font-weight: bold;margin: 0">{{ institution.INSTITUTION_NAME }}</h5>
            <div style="font-size: 12px;line-height: 20px;margin-top: 15px">{{ institution.INSTITUTION_ADDRESS }}
              <br/>
              {{ institution.INSTITUTION_CITY }},&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }} <br/>
              Ph:&nbsp;{{ institution.INSTITUTION_PHONE_NO }}<br/>
              Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}<br/>
              VAT IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }}
            </div>
          </ng-container>
        </div>
      </div>
      <!-- invoice heading-->
      <div style="font-size: 22px;font-weight: bold;padding: 15px;text-align: center;width: 100%">PURCHASE ORDER</div>

      <!--invoice and customer details-->
      <div style="display:grid;grid-template-columns: 58% 42%;">
        <!--customer details-->
        <div style="padding-right: 45px;">
          <div *ngIf="orderd.VENDOR_NAME"
               style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Supplier</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.VENDOR_NAME }}</p>
          </div>

          <div *ngIf="orderd.VENDOR_ADDRESS"
               style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Address</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.VENDOR_ADDRESS }}</p>
          </div>

          <div *ngIf="orderd.TRN_NO" style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">VAT No</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.TRN_NO }}</p>
          </div>
        </div>

        <!--invoice details-->
        <div>

          <div *ngIf="orderd.PURCHASE_ORDER_NUMBER"
               style="display: grid;grid-template-columns:32% 3% 65%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Order No</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.PURCHASE_ORDER_NUMBER }}</p>
          </div>

          <div *ngIf="orderd.PURCHASE_ORDER_DATE"
               style="display: grid;grid-template-columns:32% 3% 65%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Order Date</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.PURCHASE_ORDER_DATE | date:'dd/MM/yyyy' }}</p>
          </div>
        </div>
      </div>
      <div>
        <!--particulars-->
        <table
          style="width: 100%;border: 1px solid black;margin-top: 40px;border-collapse: collapse;border-radius: 0;">
          <thead>
          <tr style="border: 1px solid  #dee2e6;">
            <th
              style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: left;width:3%;">
              #
            </th>
            <th
              style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: left;">
              Item
            </th>
            <th
              style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: right;width:10%;">
              Quantity
            </th>
            <th
              style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: center;width:10%;">
              UOM
            </th>
            <th
              style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: right;width:15%;">
              Unit Price
            </th>
            <th
              style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: right;width:15%;">
              Total Price
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of item_list;let i=index" style="border: 1px solid  #dee2e6; ">
            <td
              style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">{{ i + 1 }}
            </td>
            <td
              style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;"> {{ item.TRADE_NAME }}
            </td>
            <td
              style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;">{{ item.QUANTITY }}
            </td>
            <td
              style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.SHORT_FORM }}
            </td>
            <td
              style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;">{{ item.UNIT_PRICE }}
            </td>
            <td
              style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;">{{ item.TOTAL_AMOUNT }}
            </td>
          </tr>
          </tbody>
        </table>

        <!--totals-->
        <table *ngIf="orderd" style="width: 100%;border: 0;border-collapse: collapse;border-radius: 0;">
          <tbody>
          <tr style="border: 1px solid #000;">
            <td colspan="2"
                style="padding: 5px !important;font-weight: bolder;font-size:18px;text-align: right;">
              Net bill
              amount : {{ orderd.GRAND_TOTAL | number : '1.2-2' }}
            </td>
          </tr>
          <tr style="border: 1px solid #000;">
            <td
              style="padding: 5px !important;text-transform:capitalize;font-size: 12px !important;text-align: left;">
              Amount in
              words &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ numberToWords }} &nbsp;Rupees
              only&nbsp;
            </td>
            <td style="padding: 5px !important;font-size: 12px !important;text-align: right"></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div style="display:grid;grid-template-columns: 58% 42%;margin-top: 30px;">
        <!--shipping details-->
        <div style="padding-right: 45px;">
          <div *ngIf="orderd.SHIP_TO" style="display: grid;grid-template-columns:35% 3% 42%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Ship To</p>
            <span>:&nbsp;</span>
            <p [innerHTML]="orderd.SHIP_TO | nl2br " style="margin: 0;font-size: 14px;"></p>
          </div>

          <div *ngIf="orderd.PAYMENT_REFERENCE"
               style="display: grid;grid-template-columns:35% 3% 42%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Payment Reference Number</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.PAYMENT_REFERENCE }}</p>
          </div>

          <div *ngIf="orderd.REFERENCE_DATE"
               style="display: grid;grid-template-columns:35% 3% 42%;align-items: flex-start;">
            <p style="margin: 0;font-size: 14px;">Reference Date</p>
            <span>:&nbsp;</span>
            <p style="margin: 0;font-size: 14px;">{{ orderd.REFERENCE_DATE | date:'dd/MM/yyyy' }}</p>
          </div>
        </div>
      </div>

      <!-- footer-->
      <div
        style="font-size: 12px;padding: 15px;text-align: center;width: 100%;position: absolute;bottom: 15px;left: 0;right: 0;">
        This is a computer-generated
        document.
        No signature is required.
      </div>
    </div>
  </div>
</div>
